import {classNames, Fragment, observer, pluralize, React} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {ContextMenuItem, useCardFieldStore, BuilderCardContextMenuItems, BuilderCardLoader, GroupSwatch, GroupByGroupContextMenu, InlineBuilderCardMenuItem, DefaultCatalogContextMenuItems, CatalogSettingsContextMenuItem, MyGroupSwatch, openInNewTab, GroupSwatchDiv, OpenInC8MenuItem, FilterForCatalogFieldValue, GroupByThisCatalogFieldMenuItem, useStores} from '@modules'
import {ICatalogFieldConfig, nav, useCatalog, WorkspaceConfig} from '@stores'
import {icons} from '@stores/ui'
import {removeUndefinedsNested} from '@utils'
import {toJS} from 'mobx'
import * as css from './CardFieldContextMenuItems.css'

export const CardFieldContextMenuItems = observer(function BuilderCardFieldContextMenuItems() {
  const store = useCardFieldStore(),
    catalog = useCatalog()

  if (!store) return null

  const {field, isFieldNested, isArray, value, editable, removeNestedItem, associatedWorkspace, data} = store,
    nestedData = store.contextMenu.extra?.data ?? data,
    isItemPromoted = _.get(data, field?.refField)?.exId === nestedData.exId
  // console.log(toJS({field, isArray, value, editable}), {recurseEverything: true})
  return (
    <Fragment>
      {/*<MenuDivider title={catalog.catalogItemName}/>*/}
      {/*<InlineBuilderCardMenuItem small showText orientation='horizontal'>*/}
      <BuilderCardContextMenuItems menuItemsTop={
        <Fragment>
          <ContextMenuItem active text={<div className={css.fieldTitle}><label>Field:</label><span className={css.fieldName}>{catalog.labelForField(field)}</span></div>} icon='property'>
            <CardFieldContextMenuTitle/>
            <MenuDivider/>

            <HideThisField/>
            <MenuDivider/>
            <FilterFieldMenuItems/>

            <GroupByThisField/>

            <OpenIn/>

            {field.esIndex && editable && value.val && <Fragment>
				<MenuDivider/>
              {!isArray && <ToggleActiveCardFieldMenuItem/>}
              {isArray && !isItemPromoted && <PromoteNestedFieldMenuItem/>}
              {value && (!isArray || !isItemPromoted) && <ContextMenuItem text={`Remove '${!isArray ? value.val?.name : pluralize(associatedWorkspace.itemName, 1)}'`} onClick={() => removeNestedItem(!isArray ? value.val : nestedData)} icon='trash'/>}
			</Fragment>
            }
            <NestedViewMenuItem/>
          </ContextMenuItem>
        </Fragment>
      }/>
      {/*</InlineBuilderCardMenuItem>*/}

      <MenuDivider/>
      <CatalogSettingsContextMenuItem/>
    </Fragment>
  )
})

const ToggleActiveCardFieldMenuItem = observer(function DeactivateCatalogItemMenuItem() {
  const store = useCardFieldStore(),
    catalog = useCatalog(),
    {strings, contextMenu, editable, associatedWorkspace, associatedWorkspace: {catalog: {index}}} = store,
    data = contextMenu.extra?.data ?? store.data,
    activeField = catalog.activeFieldFor(associatedWorkspace),
    v = _.get(data, activeField)

  if (!editable) return null

  return (<Fragment>
    <ContextMenuItem text={`${strings.toggleActive(catalog, v, false)} ${pluralize(associatedWorkspace.itemName, 1)}`}
                     onClick={() => catalog.mutations.toggleBooleanField({index, field: activeField, data})}
                     icon={v ? icons.inactive : icons.active}/>
  </Fragment>)
})

const PromoteNestedFieldMenuItem = observer(function PromoteNestedItemMenuItem() {
  const store = useCardFieldStore(),
    {associatedWorkspace, rendererStore, data: parentItemData, field} = store,
    data = store.contextMenu.extra?.data ?? store.data,
    isItemPromoted = _.get(parentItemData, field?.refField)?.exId === data.exId

  if (isItemPromoted) return null

  return (<Fragment>
    <ContextMenuItem text={`${'Target '} ${pluralize(associatedWorkspace.itemName, 1)}`}
                     onClick={() => rendererStore.onChangeSpec(data, (rendererStore.field as ICatalogFieldConfig).refField)}
                     icon={icons.arrowUp}/>
  </Fragment>)
})

const NestedViewMenuItem = observer(function NestedViewMenuItem() {
  const {isFieldNested, field} = useCardFieldStore()

  if (!isFieldNested) return null

  const {card} = field
  return (<Fragment>
    <ContextMenuItem icon='property' text='Field Renderer'>
      <ContextMenuItem icon={card?.nested?.renderer === 'card' ? 'tick' : icons.chooseSwatches} text='Swatches' onClick={() => _.merge(card, {nested: {renderer: 'card'}})}/>
      <ContextMenuItem icon={card?.nested?.renderer === 'inline' ? 'tick' : 'list-detail-view'} text='Details' onClick={() => _.merge(card, {nested: {renderer: 'inline'}})}/>
    </ContextMenuItem>
  </Fragment>)
})
/**
 * This can be a spec - empty or with rich data, the 'tags' field, some scalar attribute, an enum, etc
 */
const CardFieldContextMenuTitle = observer(function CardFieldContextMenuTitle() {
  const {value, data, library} = useCardFieldStore()

  if (!value || !library) {
    console.log(`No card to render`, {value, library, data})
    return null
  }

  if (_.isArray(value?.val)) {
    return <Fragment>
      {value.val.map((v, i) => <CardFieldContextMenuTitle_Internal key={i} value={v}/>)}
    </Fragment>
  } else {
    return <CardFieldContextMenuTitle_Internal value={value?.val}/>
  }

  return null
})

const CardFieldContextMenuTitle_Internal = observer<{ value: any }>(function CardFieldContextMenuTitle_Internal({value}) {
  if (!value) return null
  const {strings, catalog, field, library, associatedWorkspace, editable, removeNestedItem} = useCardFieldStore()
  const id = catalog.idFor(value)

  return (
    <ContextMenuItem
      className={classNames(GroupByGroupContextMenu.css.groupTitleMenuItem, css.groupTitleMenuItem)}
      text={<div className={GroupByGroupContextMenu.css.groupTitle}>
        <GroupSwatchDiv library={library} data={value}/>
        <span className={css.groupValueTitle}>{_.get(value, library.dataMap?.title ?? 'name') ?? strings.noValue}</span>
      </div>}
    >
      {!library || !value || !field ? undefined :
       <Fragment>
         <ContextMenuItem text={`Preview...`} icon={icons.previewCard} noSubmenuPadding>
           <BuilderCardLoader className={css.builderCard} hideButtons isPopover levelOfDetail={1} field={field} nested={{field, data: value}} workspace={associatedWorkspace} id={catalog.idFor(value)}/>
         </ContextMenuItem>
         <ToggleActiveCardFieldMenuItem/>
         {editable && <ContextMenuItem text={`Remove '${value?.name}'`} onClick={() => removeNestedItem(value)} icon='trash'/>}

         {associatedWorkspace && associatedWorkspace != catalog.workspaceConfig && <Fragment>
			 <MenuDivider/>
			 <OpenInWorkspaceMenuItem workspace={associatedWorkspace} id={id}/>
			 <OpenInC8MenuItem id={id}/>
		 </Fragment>}
         {field && <Fragment>
			 <FilterForCatalogFieldValue field={field.field} value={value}/>
			 <GroupByThisCatalogFieldMenuItem field={field.field}/>
		 </Fragment>}
       </Fragment>}
    </ContextMenuItem>
  )
})

const OpenIn = observer(function OpenIn() {
  const {library, associatedWorkspace, value} = useCardFieldStore(), catalog = useCatalog()
  if (_.isArray(value?.val)) return null

  const id = catalog.idFor(value?.val)

  if (!library || !id) return null

  return (<Fragment>
    <OpenInLibrary/>
    <OpenInWorkspace_CardField/>
    <MenuDivider/>
  </Fragment>)
})

const OpenInLibrary = observer(function OpenInLibrary() {
  const {library, value, stores: {sidebar}, catalog} = useCardFieldStore()

  if (!library) return null

  const id = catalog.idFor(value?.val),
    active = sidebar.left.selectedPathItem?.libraryId === library.name && _.first(sidebar.left.selectedPathItem?.where)?.value === id

  if (library && value && id) {
    return (
      <ContextMenuItem
        text={`Show ${pluralize(catalog.labelForLibrary({id: library.id}), 1)} in Library`}
        icon={icons.library}
        //active={active}
        onClick={() => active ? sidebar.left.onGoBack() : sidebar.left.navigateToLibrary({libraryId: library.id, where: [{value: id}]}, true)}
      />
    )
  }

  return null
})

export const OpenInWorkspaceMenuItem = observer<{ noTitle?: boolean, flatten?: boolean, workspace: Partial<WorkspaceConfig>, id?: string }>(({noTitle, flatten, workspace, id}) => {
  if (!workspace) return null

  const {catalog, flexLayout, catalogTab} = useStores(),
    itemId = catalog.parseIdFromPath(id),
    queryParams = nav.queryParamsFor(removeUndefinedsNested({itemId}) ?? {}),
    {urlForWorkspace} = nav,
    url = urlForWorkspace({workspace, queryParams}, true),
    urlInSidebar = urlForWorkspace({workspace, queryParams: {...queryParams, ...catalog.queryParamsFor({detailLoc: 'sidebar'})}}, true),
    urlInModal = urlForWorkspace({workspace, queryParams: {...queryParams, ...catalog.queryParamsFor({detailLoc: 'modal'})}}, true)

  // console.log({urlInSidebar, urlInModal, url})
  const openMenuItems = <Fragment>
    <ContextMenuItem icon={icons.sidebar} text={'Open in New Tab (Sidebar)'} isDefaultAction shouldDismissPopover onClick={() => openInNewTab(urlInSidebar)}/>
    <ContextMenuItem icon={icons.modal} text={'Open in New Tab (Modal)'} shouldDismissPopover onClick={() => openInNewTab(urlInModal)}/>
    <ContextMenuItem icon={icons.sidebar} text={'Open Here'} shouldDismissPopover onClick={() => nav.routeTo({workspace, queryParams, verb: 'push'})}/>
    <MenuDivider/>
    <ContextMenuItem icon='link' text={'Copy Link Address'} shouldDismissPopover onClick={() => navigator.clipboard.writeText(`${window.location.protocol}//${window.location.host}${url}`)}/>
  </Fragment>

  // console.log({url, urlInModal, urlInSidebar})
  return (
    <Fragment>
      {flatten ? noTitle ? null : <MenuDivider title={`${workspace.title} Workspace`}/>
               : <ContextMenuItem
         text={`Open in ${workspace.title} Workspace`}
         icon={icons.workspace}
         onClick={() => flexLayout.create.newCatalogTab({
           selectNewTab: true,
           parentTabSet: catalogTab?.tabSet,
           //location: 'right',
           workspace,
           config: {
             settings: {
               catalog: {
                 focusedCatalogItemId: itemId,
                 focusToHierarchy: true
               }
             }
           }
         })}
         // children={flatten ? undefined : openMenuItems}
         //active={active}
       />}
      {flatten && openMenuItems}
    </Fragment>
  )
})

const OpenInWorkspace_CardField = observer(function OpenInWorkspace() {
  const catalog = useCatalog(),
    {library, value} = useCardFieldStore()

  if (!library) return null

  const workspace = catalog.workspaceByIndex[library.index]

  if (!workspace) return null

  const id = catalog.idFor(value?.val)

  return library && value && id && <OpenInWorkspaceMenuItem workspace={workspace} id={id}/>
})

const HideThisField = observer(function HideThisField() {
  const catalog = useCatalog(),
    {field} = useCardFieldStore(),
    isSelected = catalog.cardView[field.field]

  return <ContextMenuItem icon={isSelected ? 'eye-off' : 'eye-on'}
                          text={isSelected ? 'Hide this Field' : 'Show this Field'}
                          onClick={() => catalog.toggleCardField(field)}/>
})

const GroupByThisField = observer(function GroupByThisField() {
  const catalog = useCatalog(),
    {groupBy} = useCatalog(),
    {grouping, field} = useCardFieldStore(),
    {hierarchyGroups} = groupBy

  const groupTitle = grouping?.groupTitle ?? catalog.labelForField(field)

  const r = hierarchyGroups.some(hg => hg === grouping) ? <ContextMenuItem icon={'trash'} text={`Stop grouping by '${pluralize(groupTitle)}'`} onClick={() => groupBy.onClickGroupBy_modifyHierarchy(grouping.groupName)}/>
                                                        : grouping ? <ContextMenuItem icon={hierarchyGroups.length === 0 ? icons.groupByH1 : hierarchyGroups.length === 1 ? icons.groupByH2 : 'header'}
                                                                                      text={`Group by '${pluralize(groupTitle)}'`}
                                                                                      onClick={() => groupBy.onClickGroupBy_modifyHierarchy(grouping.groupName)}/>
                                                                   : null

  return r ? <Fragment>
    <MenuDivider/>
    {r}
  </Fragment> : null
})

const FilterFieldMenuItems = observer(() => {
  const {textValue} = useCardFieldStore()

  if (textValue) {
    return <Fragment>
      <MenuDivider/>
      <FilterThisField/>
      <FilterExcludeThisField/>
    </Fragment>
  }

  return null
})

const FilterThisField = observer(function FilterThisField() {
  const {textValue, onFilterValue, isFiltered} = useCardFieldStore()

  return textValue ? <ContextMenuItem icon={'filter'} text={`Filter this Value`} onClick={onFilterValue}/> : null
})

const FilterExcludeThisField = observer(function FilterExcludeThisField() {
  const {textValue, filter_excludeValue, isExcluded} = useCardFieldStore()

  return textValue ? <ContextMenuItem active={isExcluded} icon={isExcluded ? 'plus' : 'cross'} text={`${isExcluded ? 'Include' : 'Filter out'} this Value`} onClick={filter_excludeValue}/> : null
})

/*<ContextMenuItem_Submenu_NoPadding
		  className={css.groupTitleMenuItem}
		  text={<div className={css.groupTitle}>
            <GroupSwatch borderIfObjectFitCover/>
            {groupLabel}
          </div>}
	  >
        {!esInfo && fieldDefinition ? undefined : <BuilderCardLoader className={css.builderCard} hideButtons isPopover levelOfDetail={1} nested={{field: fieldDefinition, data: esInfo}} id={catalog.idFor(esInfo)}/>}
	  </ContextMenuItem_Submenu_NoPadding>
*/


// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/CardFieldContextMenuItems.tsx